import { hasKeyOfType } from '@dicetechnology/doris-core';

import type { PlaylistLoadRequest } from '../services';

export const isPlaylistLoadRequest = (value: unknown): value is PlaylistLoadRequest => {
    return (
        typeof value === 'object' &&
        value !== null &&
        hasKeyOfType(value, 'id', 'string') &&
        hasKeyOfType(value, 'startingContentId', 'string') &&
        hasKeyOfType(value, 'type', 'string')
    );
};
